/**
 * @generated SignedSource<<e1cf8160038aa7b25622cf2aac7abc2b>>
 * @relayHash 0b30cf51e146f0fe5a8d45c83534f970
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9ce2656bf7be9dfd57cbfb4f25c8ea7a6f43bfa2d15f446117214e5f7e4c6ba

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FieldsPageContentQuery$variables = {
  cloudId: string;
  preloadedFieldId: string;
  projectKey: string;
  shouldEnforceLimits: boolean;
  shouldPreloadField: boolean;
};
export type FieldsPageContentQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly isExplicitFieldAssociationsEnabled: boolean | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"DeepLinkSidebar" | "FieldsPageHeader">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"FieldsPageHeader_limits">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"FieldsTable">;
};
export type FieldsPageContentQuery = {
  response: FieldsPageContentQuery$data;
  variables: FieldsPageContentQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": isNumberFieldConfigurationEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": includeSingleSelectColorField_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isNumberFieldConfigurationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-ui-enabled.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colourful-single-select-fields-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "preloadedFieldId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldEnforceLimits"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldPreloadField"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "shouldEnforceLimits",
  "variableName": "shouldEnforceLimits"
},
v7 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "isExplicitFieldAssociationsEnabled"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "key"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v14 = {
  "kind": "ScalarField",
  "name": "scope"
},
v15 = {
  "kind": "ScalarField",
  "name": "typeName"
},
v16 = {
  "kind": "ScalarField",
  "name": "description"
},
v17 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v18 = {
  "kind": "ScalarField",
  "name": "hasMissingConfiguration"
},
v19 = {
  "kind": "ScalarField",
  "name": "canRemove"
},
v20 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v21 = {
  "kind": "ScalarField",
  "name": "canModifyOptions"
},
v22 = {
  "concreteType": "JiraFieldOptionConnection",
  "kind": "LinkedField",
  "name": "fieldOptions",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraFieldOptionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraFieldOption",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "optionId"
            },
            {
              "kind": "ScalarField",
              "name": "parentOptionId"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "JiraColor",
                  "kind": "LinkedField",
                  "name": "color",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "colorKey"
                    },
                    (v11/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v24 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "fieldFormatConfig",
      "plural": false,
      "selections": [
        (v23/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "formatStyle"
            },
            {
              "kind": "ScalarField",
              "name": "formatUnit"
            },
            {
              "kind": "ScalarField",
              "name": "formatDecimals"
            }
          ],
          "type": "JiraNumberFieldFormatConfig"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FieldsPageContentQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          },
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "FieldsTable"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "FieldsPageHeader_limits"
          },
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "args": [
                  (v6/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "FieldsPageHeader"
              },
              {
                "condition": "shouldPreloadField",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "preloadedFieldId",
                        "variableName": "preloadedFieldId"
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "DeepLinkSidebar"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "FieldsPageContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "xsmall"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "optionsPerFieldLimit"
              },
              {
                "concreteType": "JiraFieldTypeGroupConnection",
                "kind": "LinkedField",
                "name": "projectFieldTypeGroups",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldTypeGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldTypeGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "projectScopedFieldsPerProjectLimit"
              },
              {
                "kind": "ScalarField",
                "name": "projectScopedFieldsCount"
              },
              (v11/*: any*/),
              {
                "concreteType": "JiraProjectWithIssueTypeIds",
                "kind": "LinkedField",
                "name": "projectWithVisibleIssueTypeIds",
                "plural": false,
                "selections": [
                  {
                    "args": (v12/*: any*/),
                    "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                    "kind": "LinkedField",
                    "name": "fieldAssociationWithIssueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v11/*: any*/),
                                  (v9/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/)
                                ]
                              },
                              (v18/*: any*/),
                              {
                                "concreteType": "JiraFieldOperation",
                                "kind": "LinkedField",
                                "name": "fieldOperation",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "canDelete"
                                  },
                                  (v20/*: any*/),
                                  (v21/*: any*/)
                                ]
                              },
                              (v22/*: any*/),
                              (v24/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isFieldLocked"
                              },
                              (v23/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ],
                    "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                  },
                  {
                    "args": (v12/*: any*/),
                    "filters": [
                      "input"
                    ],
                    "handle": "connection",
                    "key": "fieldsTable_fieldAssociationWithIssueTypes",
                    "kind": "LinkedHandle",
                    "name": "fieldAssociationWithIssueTypes"
                  }
                ]
              },
              (v8/*: any*/),
              {
                "condition": "shouldEnforceLimits",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectWithIssueTypeIds",
                    "kind": "LinkedField",
                    "name": "projectWithVisibleIssueTypeIds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "fieldAssociationWithIssueTypesCount",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                          }
                        ],
                        "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                        "kind": "LinkedField",
                        "name": "fieldAssociationWithIssueTypes",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "totalCount"
                          }
                        ],
                        "storageKey": "fieldAssociationWithIssueTypes(first:1)"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "shouldPreloadField",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectWithIssueTypeIds",
                    "kind": "LinkedField",
                    "name": "projectWithVisibleIssueTypeIds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "preloadedField",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "fieldId",
                            "variableName": "preloadedFieldId"
                          }
                        ],
                        "concreteType": "JiraFieldAssociationWithIssueTypes",
                        "kind": "LinkedField",
                        "name": "fieldAssociationWithIssueTypesByFieldId",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/),
                              (v9/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          (v22/*: any*/),
                          (v18/*: any*/),
                          {
                            "concreteType": "JiraFieldOperation",
                            "kind": "LinkedField",
                            "name": "fieldOperation",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/)
                            ]
                          },
                          (v24/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "shouldEnforceLimits",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v5/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filterKeys",
                    "value": [
                      "fields.per.project.limit"
                    ]
                  }
                ],
                "concreteType": "JiraResourceUsageMetricLimitValue",
                "kind": "LinkedField",
                "name": "limitValues",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "limitValue"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d9ce2656bf7be9dfd57cbfb4f25c8ea7a6f43bfa2d15f446117214e5f7e4c6ba",
    "metadata": {},
    "name": "FieldsPageContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": isNumberFieldConfigurationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};
})();

(node as any).hash = "df4fc3ae5067e347c2b017413f09140a";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
